
import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

import axios from 'axios';

const ModalEditarServico = (props) => {

    const [codigo, setCodigo] = useState('');
    const [discriminacao, setDiscriminacao] = useState('');
    const [cnae, setCnae] = useState('');
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem('token');

    useEffect(() => {
        const getServico = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/buscarServicoById/${props.idServico}`, {
                headers: {
                    Authorization: token
                }
            });
            if (response.data.status === 200) {
                const servico = response.data.servico;
                setCodigo(servico.codigo);
                setDiscriminacao(servico.discriminacao);
                setCnae(servico.cnae);
            }
        }
        getServico();
    }, [props.idServico, token]);

    const handleClose = () => {
        setCodigo('');
        setDiscriminacao('');
        setCnae('');
        props.setOpenModalEditarServico(false);
    };

    const handleAgree = async () => {
        setLoading(true);

        if (!codigo || !discriminacao) {
            alert('Por favor, preencha todos os campos.');
            setLoading(false);
            return;
        }

        const response = await axios.put(`${process.env.REACT_APP_API_URL}/editarServico/${props.idServico}`, {
            codigo,
            codigoTributacao: codigo,
            discriminacao,
            cnae,
        }, {
            headers: {
                Authorization: token,
                'Content-Type': 'application/json'
            }
        });
        if (response.data.status === 200) {
            setLoading(false);
            props.setOpenModalEditarServico(false);
        } else {
            alert('Erro ao editar serviço. Tente novamente.');
            setLoading(false);
        }
    }
    return (
        <React.Fragment>
            <Dialog
                open={props.openModalEditarServico}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Editar Serviço"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Por favor, preencha os detalhes do serviço que deseja editar.
                    </DialogContentText>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: '16px', marginTop: '16px' }}>
                        <TextField label="Código" value={codigo} onChange={(e) => setCodigo(e.target.value)} variant="outlined" size='small' sx={{ width: "48%" }} />
                        <TextField label="cnae" value={cnae} onChange={(e) => setCnae(e.target.value)} variant="outlined" size='small' sx={{ width: "48%" }} />
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', gap: '16px', marginTop: '16px' }}>
                        <TextField
                            label="Discriminacao"
                            placeholder="Descreva o serviço aqui"
                            rows={4}
                            multiline
                            fullWidth
                            value={discriminacao}
                            onChange={(e) => setDiscriminacao(e.target.value)}
                        />
                    </div>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', px: 3, pb: 2 }}>
                    <Button onClick={handleClose} loading={loading} autoFocus color='error' size='small'>Cancelar</Button>
                    <Button onClick={handleAgree} loading={loading} variant='contained' color='success' size='small'>Editar Serviço</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default ModalEditarServico;